import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Gets warnings whenever the current space entity changes.
 */
export const loadForCurrentEntityOnEntityChange = store.effects.create(
  <TTypeParams extends ec.models.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.plugins.currentEntityPlugin.feature.selectors
      .getId()
      .asObservable.pipe(
        rxjs.distinctUntilChanged(),
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from('(effect) load for current entity on entity change')
            .create(),
        ),
      ),
)
